import { Col, Form, Input, Radio, Row, Select } from "antd";
import { getDocs, collection } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../../../../../firebase";
import Financials from "./Financials";

const months = [
  {
    value: "January",
  },
  {
    value: "February",
  },
  {
    value: "March",
  },
  {
    value: "April",
  },
  {
    value: "May",
  },
  {
    value: "June",
  },
  {
    value: "July",
  },
  {
    value: "August",
  },
  {
    value: "September",
  },
  {
    value: "October",
  },
  {
    value: "November",
  },
  {
    value: "December",
  },
];

function OwnersAndFinancials({financials, setFinancials,companyName,isCompanyNameFetched}) {
  const [paymentType, setPaymentType] = useState("Net Income");
  const [owners, setOwners] = useState([]);

  useEffect(()=>{
    if (!isCompanyNameFetched) return;
    const fetchOwners = async () => {
      try {
        const ownerRef = collection(
          db,
          "companies",
          companyName,
          "owners"
        );
        const snapshot = await getDocs(ownerRef); 
        const fetchedData = snapshot.docs.map((doc) => ({
          id: doc.id,
          value: doc.id,
          label: doc.data().ownerInfo.firstName + doc.data().ownerInfo.lastName,
          ...doc.data(),
        }));
        setOwners(fetchedData);
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    };
    fetchOwners();
  },[companyName,isCompanyNameFetched]);

  console.log("owners", owners);
  return (
    <>
      <Row gutter={[8, 0]}>
        <Col className="tableHead" span={10}>
          <p>Owner</p>
        </Col>
        <Col className="tableHead" span={7}>
          <p>Percent Owned</p>
        </Col>
        <Col className="tableHead" span={6}>
          <p>Contract Expires</p>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Financials options={owners} financials={financials} setFinancials={setFinancials} companyName={companyName}/>
      <p>Total: 0%</p>
      <br />
      <br />
      <p className="onclick-text">Create New Owner</p>
      <Form.Item name="paymentType" label="Payment Type">
        <Radio.Group
          name="radiogroup"
          value={paymentType}
          onChange={(e) => {
            setPaymentType(e.target.value);
          }}
        >
          <Radio value="Net Income">Net Income</Radio>
          <Radio value="Flat">Flat</Radio>
        </Radio.Group>
      </Form.Item>
      {paymentType === "Flat" && (
        <Form.Item label="Payment Amount" name="paymentAmount">
          <Input prefix="$" />
        </Form.Item>
      )}
      <Form.Item label="Reserved Funds" name="reservedFunds">
        <Input prefix="$" />
      </Form.Item>
      <Form.Item label="Vendor 1099 Payer" name="vendor1099">
        <Select options={[{ value: "Use Portfolio Test 1" }]} />
      </Form.Item>
      <Form.Item label="Fiscal Year End" name="fiscalYearEnd">
        <Select options={months} />
      </Form.Item>
      <Form.Item label="Basis for Owner Packets" name="basisForOwnerPackets">
        <Select options={[{ value: "Cash" }, { value: "Accrual" }]} />
      </Form.Item>
    </>
  );
}

export default OwnersAndFinancials;
